// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__hj-bu","header":"Tabs_header__Z-beB","tab":"Tabs_tab__xnh3B","active":"Tabs_active__zLkbq"};